module.exports = __webpack_public_path__ + "img/MLR00.cc894121.png";